import routerConstants from '@/const/routerConstants';

export default [
  // settings
  {
    name: routerConstants.SettingMenu,
    path: '/settingMenu',
    component: () => import('@/views/settings/SettingMenuView.vue'),
  },
  {
    name: routerConstants.ServicePolicy,
    path: '/servicePolicy',
    component: () => import('@/views/settings/policy/ServiceView.vue'),
  },
  {
    name: routerConstants.PrivacyPolicy,
    path: '/privacyPolicy',
    component: () => import('@/views/settings/policy/PrivacyView.vue'),
  },
  {
    name: routerConstants.PasswordChange,
    path: '/passwordChange',
    component: () => import('@/views/settings/PasswordChangeView.vue'),
  },
];
